<template>
    <v-card>
        <v-card-title>
            <p class="text-center">Управление аккаунтами медиацентра</p>
        </v-card-title>
        <v-card-subtitle>
            <span>Пользователь панели</span>
        </v-card-subtitle>
        <v-card-text>
            <v-row>
                <v-col cols="3">
                    <v-text-field disabled label="Логин пользователя" v-model="userPanel.name"/>
                </v-col>
                <v-col cols="3">
                    <v-text-field label="Новый пароль"
                                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                  :type="showPassword ? 'text' : 'password'"
                                  @click:append="showPassword = !showPassword"
                                  v-model="userPanel.password"/>
                </v-col>
                <v-col cols="3">
                    <v-text-field label="Повторите пароль"
                                  :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                  :type="showNewPassword ? 'text' : 'password'"
                                  :error-messages="error"
                                  @click:append="showNewPassword = !showNewPassword"
                                  v-model="newPassword"/>
                </v-col>
                <v-col cols="3">
                    <v-btn color="#cc7b19" small @click="saveUser">сохранить</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" class="text-center">
                    <span class="done">{{ doneSaveUser }}</span>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-subtitle>
            <span>Аккаунт Кинозал.TV</span>
        </v-card-subtitle>
        <v-card-text>
            <v-row>
                <v-col cols="4">
                    <v-text-field label="Логин" v-model="accountKinozal.username"/>
                </v-col>
                <v-col cols="4">
                    <v-text-field label="Пароль"
                                  :append-icon="showAccPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                  :type="showAccPassword ? 'text' : 'password'"
                                  @click:append="showAccPassword = !showAccPassword"
                                  v-model="accountKinozal.password"/>
                </v-col>
                <v-col cols="4">
                    <v-btn color="#cc7b19" small @click="saveAccount('kinozal')">сохранить</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" class="text-center">
                    <span class="done">{{ doneSaveAccountKinozal }}</span>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-subtitle>
            <span>Аккаунт RuTracker.org</span>
        </v-card-subtitle>
        <v-card-text>
            <v-row>
                <v-col cols="4">
                    <v-text-field label="Логин" v-model="accountRutracker.username"/>
                </v-col>
                <v-col cols="4">
                    <v-text-field label="Пароль"
                                  :append-icon="showAccPasswordR ? 'mdi-eye' : 'mdi-eye-off'"
                                  :type="showAccPasswordR ? 'text' : 'password'"
                                  @click:append="showAccPasswordR = !showAccPasswordR"
                                  v-model="accountRutracker.password"/>
                </v-col>
                <v-col cols="4">
                    <v-btn color="#cc7b19" small @click="saveAccount('rutracker')">сохранить</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" class="text-center">
                    <span class="done">{{ doneSaveAccountRutracker }}</span>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "userAndAccount",
    data() {
        return {
            error: '',
            doneSaveUser: '',
            doneSaveAccountKinozal: '',
            doneSaveAccountRutracker: '',
            showPassword: false,
            showNewPassword: false,
            showAccPassword: false,
            showAccPasswordR: false,
            userPanel: {},
            newPassword: '',
            accountKinozal: {},
            accountRutracker: {}
        }
    },
    created() {
        this.getAccount()
        this.getUser()
        this.$store.dispatch('updateToken')
    },
    methods: {
        getUser() {
            this.$http.get('/getUser').then((resp) => {
                this.userPanel = resp.data
            })
        },
        getAccount() {
            this.$http.get('/getAccount').then((resp) => {
                this.accountKinozal = resp.data[0]
                this.accountRutracker = resp.data[1]
            })
        },
        saveUser() {
            if (this.userPanel.password !== this.newPassword) {
                this.error = 'Пароли не совпадают'
            } else {
                this.error = ''
                this.$http.post('/updateUser/' + this.userPanel.id, this.userPanel).then((resp) => {
                    this.doneSaveUser = resp.data
                })
            }
        },
        saveAccount(name) {
            if (name === 'kinozal') {
                this.$http.post('/accountUpdate/' + name, this.accountKinozal).then((resp) => {
                    this.doneSaveAccountKinozal = resp.data
                })
            } else if (name === 'rutracker') {
                this.$http.post('/accountUpdate/' + name, this.accountRutracker).then((resp) => {
                    this.doneSaveAccountRutracker = resp.data
                })
            }
        }
    }
}
</script>

<style scoped>
.done {
    color: #00e676;

}
</style>